import { Colors } from '../colors/colors';

export const addShippingConditionalStyles = (data) =>
	(!data?.shipping && {
		color: Colors.darkGray2,
		cursor: 'default',
	}) ||
	{};
